var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.71967 3.21967C8.01256 2.92678 8.48744 2.92678 8.78033 3.21967C9.07322 3.51256 9.07322 3.98744 8.78033 4.28033L6.06066 7H12.25C12.6642 7 13 7.33579 13 7.75C13 8.16421 12.6642 8.5 12.25 8.5H6.06066L8.78033 11.2197C9.07322 11.5126 9.07322 11.9874 8.78033 12.2803C8.48744 12.5732 8.01256 12.5732 7.71967 12.2803L3.71967 8.28033C3.42678 7.98744 3.42678 7.51256 3.71967 7.21967L7.71967 3.21967Z","fill":"#6A5FC1"}));
}

ArrowRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
